module.exports = __webpack_public_path__ + "static/img/img_serve5.801ed1a3.png";